//====================================================
//  Function: Tooltip
//====================================================
function componentTooltip() {
  if ($('.js-tooltip').length) {
    var tooltip
    tooltip = tippy('.js-tooltip', {
      placement: 'top-end',
      animation: 'shift-away',
      allowHTML: true,
      trigger: 'click',
      interactive: true,
      arrow: true,
    })

    $(document).on('click', '.js-tooltip-close', function (e) {
      for (let i = 0; i < tooltip.instances.length; i++) {
        tooltip.instances[i].hide()
      }
      // hideAll()
      e.preventDefault()
    })
  }

  if ($('.js-tooltip-classic').length) {
    var tooltip
    tooltip = tippy('.js-tooltip-classic', {
      placement: 'top-center',
      animation: 'shift-away',
      allowHTML: true,
      interactive: true,
      arrow: true,
    })
  }
}
